export default function convertImagekit(img, size) {
  if (img?.match('imagekit') && !img?.match('tr=')) {
    return img + (size ? `?tr=w-${size},h-${size}` : '')
  }

  return img
}
